import { MediaOverlayProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: MediaOverlayProps = {
  media: <div />,
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as MediaOverlayProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
